import React, { useState, useEffect } from "react";
import ReactGA from "react-ga";
import styled from "@emotion/styled";
import { useTransition, animated } from "react-spring";
// import { TweenMax } from "gsap";

const TopBox = styled.div`
  cursor: pointer;
  position: fixed;
  right: 0px;
  bottom: 50px;
  width: 50px;
  height: 120px;
  background-color: rgba(255, 0, 0, 0.4);
  border-top: 1px solid #ff0000;
  border-left: 1px solid #ff0000;
  border-bottom: 1px solid #ff0000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 767px) {
    width: 40px;
    height: 100px;
  }
`;

const Square = styled.div`
  width: 16px;
  height: 16px;
  border-top: 2px solid #fff;
  border-left: 2px solid #fff;
  transform: rotate(45deg);
`;

const Text = styled.p`
  font-size: 1.125em;
  color: #fff;
  @media screen and (max-width: 767px) {
    font-size: 12px;
  }
`;

const Top = () => {
  const [isShow, setIsShow] = useState(false);
  const show = useTransition(isShow, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 }
  });

  useEffect(() => {
    const scrollEvent = () => {
      if (window.pageYOffset > 200) {
        if (!isShow) {
          setIsShow(true);
        }
      } else {
        if (isShow) {
          setIsShow(false);
        }
      }
    };

    window.addEventListener("scroll", scrollEvent);
    return () => {
      window.removeEventListener("scroll", scrollEvent);
    };
  }, [isShow]);

  const onClick = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
    ReactGA.event({
      category: "202012_PRADO",
      action: "Click",
      label: "Btn-Top",
    });
  };

  return (
    <>
      {show.map(({ item, key, props }) => {
        return (
          item && (
            <animated.div style={props} key={key}>
              <TopBox onClick={onClick}>
                <Square />
                <Text>T</Text>
                <Text>O</Text>
                <Text>P</Text>
              </TopBox>
            </animated.div>
          )
        );
      })}
    </>
  );
};

export default Top;
